const CATALOGUE_PREFIX = '@@catalogue/';

export const CATALOGUE_ACTION_TYPES = {
    FETCH_REQUEST: `${CATALOGUE_PREFIX}FETCH_REQUEST`,
    FETCH_SUCCESS: `${CATALOGUE_PREFIX}FETCH_SUCCESS`,
    FETCH_FAILURE: `${CATALOGUE_PREFIX}FETCH_FAILURE`,
};